import apiClient, { fileUploadClient } from "./Environment";

export default {
  getRestaurantProducts(params) {
    return apiClient.get("/get-revenue-restaurant-products", {
      params
    });
  },
  loadRevenueDate(params) {
    return apiClient.get("/revenue-restaurant-load-day", { params });
  },
  saveRevenueDay(params) {
    return apiClient.get("/revenue-restaurant-save-day", { params });
  },
  removeRevenueDay(params) {
    return apiClient.get("/revenue-restaurant-remove-day", { params });
  },
  uploadRestaurantDataFile(params) {
    return fileUploadClient.post("/revenue-restaurant-import", params);
  },
  getRestaurantDataFileStatus(params) {
    return apiClient.get("/revenue-restaurant-import-status", {
      params
    });
  },
  getCurrentMonthReport(params) {
    return apiClient.get("/getcurrentmonthreport", { params });
  },
  getCurrentMonthList(params) {
    return apiClient.get("/getcurrentmonthlist", { params });
  },
  getCurrentYearReport(params) {
    return apiClient.get("/getcurrentyearreport", { params });
  },
  getCurrentYearList(params) {
    return apiClient.get("/getcurrentyearlist", { params });
  },
  getPastMonthReport(params) {
    return apiClient.get("/getpastmonthreport", { params });
  },
  getPastMonthList(params) {
    return apiClient.get("/getpastmonthlist", { params });
  },
  getPastYearReport(params) {
    return apiClient.get("/getpastyearreport", { params });
  },
  getPastYearList(params) {
    return apiClient.get("/getpastyearlist", { params });
  },
  getAvailableMonths(params) {
    return apiClient.get("/getavailablemonths", { params });
  },
  getAvailableYears(params) {
    return apiClient.get("/getavailableyearreport", { params });
  }
};
